/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getRewardStatus} from '../api'

 export const useQueryGetRewardStatus = createReactQueryHook('getRewardStatus', getRewardStatus)
